'use client'

import { createGlobalStyle } from 'styled-components'
import styledNormalize from 'styled-normalize'
import { themeGet } from '@styled-system/theme-get'

import swipersCss from './swipers'

const GlobalStyles = createGlobalStyle`
  ${styledNormalize}


  html {
    width: 100%;
    height: 100dvh;
  }

  body {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: ${themeGet('fonts.primary')};
    line-height: 20px;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    box-sizing: border-box;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-overflow-scrolling: touch;
  }


  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  button {
    background: none;
    border: none;
    outline: none;
    padding: 0;
    cursor: pointer;
  }

  ${swipersCss}
`

export default GlobalStyles
